import request from '@/utils/request'

//获取验证码
export function captcha(params) {
  return request({
    url: '/client/captcha',
    mockPath: '/captcha',
    method: 'get',
    params
  })
}

//登录
export function login(data) {
  return request({
    url: '/client/login',
    mockPath: '/login',
    method: 'post',
    data
  })
}

//登录
export function register(data) {
  return request({
    url: '/client/register',
    mockPath: '/login',
    method: 'post',
    data
  })
}

//刷新令牌
export function refresh(rt) {
  return request({
    url: '/client/refresh?rt=' + rt,
    mockPath: '/refresh',
    method: 'put',
    
  })
}

//获取用户信息
export function info(params) {
  return request({
    url: '/client/info',
    mockPath: '/info',
    method: 'get',
    params
  })
}

//登出
export function logout() {
  return request({
    url: '/client/logout',
    mockPath: '/submit',
    method: 'delete'
  })
}


//刷新令牌
export function modifyAccount(data) {
  return request({
    url: '/client/modify-passwd' ,
    mockPath: '/submit',
    method: 'put',
    data
  })
}

//获取数据字典
// export function getDict(code) {
//   return request({
//     url: '/admin/dict/code/'+code,
//     mockPath: '/dictCode',
//     method: 'get',
//     params
//   })
// }
